import React, { useState } from "react";
import { UpArrowCardIcon, DownArrowCardIcon } from "../../assets/Icons";
import Button from "../../components/common/button/button";
import { useTranslation } from "../../contexts/TranslationContext";

export const KaratHelpAccordion: React.FC = () => {
  const [open, setOpen] = useState(false);
  const t = useTranslation();
  return (
    <div className={`weight-slider__help karat-accordion${open ? " open" : ""}`}>
      <button className="weight-slider__help-header" onClick={() => setOpen((p) => !p)}>
        <span>{t.gold.needHelp}</span>
        {open ? <UpArrowCardIcon /> : <DownArrowCardIcon />}
      </button>
      {open && (
        <div className="weight-slider__help-content">
          <p>{t.gold.karatHelp}</p>
          <p>On <strong>{t.gold.karatRingsBold}</strong>{t.gold.karatRingsRest}</p>
          <p>On <strong>{t.gold.karatNecklacesBold}</strong>{t.gold.karatNecklacesRest}</p>
          <p>On <strong>{t.gold.karatEarringsBold}</strong>{t.gold.karatEarringsRest}</p>
        </div>
      )}
    </div>
  );
};

export const PurityHelpAccordion: React.FC<{ metalName: string }> = ({ metalName }) => {
  const [open, setOpen] = useState(false);
  const t = useTranslation();
  const isSilver = metalName === "Silver";
  return (
    <div className={`weight-slider__help karat-accordion${open ? " open" : ""}`}>
      <button className="weight-slider__help-header" onClick={() => setOpen((p) => !p)}>
        <span>{t.gold.needHelp}</span>
        {open ? <UpArrowCardIcon /> : <DownArrowCardIcon />}
      </button>
      {open && (
        <div className="weight-slider__help-content">
          {isSilver ? (
            <>
              <p>{t.gold.purityHelp}</p>
              <div className="weight-slider__help-purity-list">
                <p><strong>99.9%(999)</strong>{t.gold.alsoKnownAs}<strong>Fine silver</strong></p>
                <p><strong>92.5%(925)</strong>{t.gold.alsoKnownAs}<strong>Sterling silver</strong></p>
                <p><strong>90%(900)</strong></p>
                <p><strong>80%(800)</strong></p>
              </div>
            </>
          ) : (
            <>
              <p>{t.gold.purityHelp}</p>
              <div className="weight-slider__help-purity-list">
                <p><strong>95%(950)</strong>{t.gold.or}<strong>PT950</strong></p>
                <p><strong>90%(900)</strong>{t.gold.or}<strong>PT900</strong></p>
                <p><strong>85%(850)</strong>{t.gold.or}<strong>PT850</strong></p>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

type GoldTextAreaProps = {
  initialValue: string;
  onContinue: (text: string) => void;
};

export const GoldTextAreaAttribute: React.FC<GoldTextAreaProps> = ({ initialValue, onContinue }) => {
  const [text, setText] = useState(initialValue);
  const t = useTranslation();
  const MAX_CHARS = 500;
  return (
    <div className="gold-textarea-wrapper">
      <textarea
        className="gold-textarea"
        placeholder={t.gold.additionalComments}
        value={text}
        onChange={(e) => setText(e.target.value.replace(/\p{Extended_Pictographic}/gu, '').slice(0, MAX_CHARS))}
        rows={5}
      />
      <div className="gold-textarea__counter">{text.length}/{MAX_CHARS}</div>
      <div className="continue-button-container-gold">
        <Button label={t.shared.continue} onClick={() => onContinue(text.trim())} styleType="primary" />
      </div>
    </div>
  );
};
